// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"1b67daf5","213":"46f7f7e0","239":"1d1fec74","252":"978d65bd","276":"fd81e349","378":"b8818c90","455":"291c3e3b","534":"5a9fe1d8","540":"8b7e21d5","854":"736b79cf"}[chunkId] + ".chunk.js";
};